import styled from 'styled-components';

export const PageTemplate = styled.div`
  background-color: #fff;
`;

export const Wrap = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
`;
